<div class="position-relative"
     style="width: 100%; height: 200px; border-radius: 1rem; border: darkgrey 2px solid; box-shadow: 0 0 20px 0 rgb(0, 0 ,0 , 0.2)">
  <div class="p-3">
    <h1>
      <sb-icon [icon]="icon"></sb-icon>
    </h1>
    <h1>{{value}}</h1>
    <h6>{{description}}</h6>
  </div>
  <sb-icon icon="barChart" class="icon-bottom-right"></sb-icon>
</div>
